module.exports = __webpack_public_path__ + "img/walls-right-desktop.592cc55b.png";